import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../../../AccountForm.meta';
import { AnnuitizationDistributionDuration } from '../../../AnnuitizationDistributionDuration/AnnuitizationDistributionDuration';
import { AnnuityAnnualReturn } from '../../../AnnuityAnnualReturn/AnnuityAnnualReturn';
import { AnnuityDistributionOption } from '../../../AnnuityDistributionOption/AnnuityDistributionOption';
import { AnnuityPrincipalControl } from '../../../AnnuityPrincipalControl/AnnuityPrincipalControl';
import { AnnuityPurchaseYear } from '../../../AnnuityPurchaseYear/AnnuityPurchaseYear';
import { AnnuitySurrenderSchedule } from '../../../AnnuitySurrenderSchedule/AnnuitySurrenderSchedule';
import { AnnuitySurvivorBenefit } from '../../../AnnuitySurvivorBenefit/AnnuitySurvivorBenefit';
import { MonthlyDistributionAmount } from '../../../MonthlyDistributionAmount/MonthlyDistributionAmount';

export const FixedAnnuitizationByYear = () => {
  const { watch } = useFormContext<FormFields>();

  const [
    annuityIsAnnuitized,
    annuityIsAlreadyAnnuitized,
    annuitizationStartYear,
    annuitizationStartAtRetirement,
    annuityDistributionOption,
  ] = watch([
    'bankAccount.AnnuityIsAnnuitized',
    'bankAccount.AnnuityIsAlreadyAnnuitized',
    'bankAccount.AnnuitizationStartYear',
    'bankAccount.AnnuitizationStartAtRetirement',
    'bankAccount.AnnuityDistributionOption',
  ]);

  const isAlreadyAnnuizided = annuityIsAnnuitized && annuityIsAlreadyAnnuitized;
  const isAnnuitizationYear =
    annuityIsAnnuitized && annuitizationStartYear !== null && !annuityIsAlreadyAnnuitized;
  const isAnnuitizationStartAtRetirement = annuitizationStartAtRetirement;

  const isStraightLife = annuityDistributionOption === 0;
  const isSurvivorShip = annuityDistributionOption === 1;
  const isPeriodCertain = annuityDistributionOption === 2;

  if (isAlreadyAnnuizided || isAnnuitizationYear || isAnnuitizationStartAtRetirement) {
    return (
      <>
        <AnnuityDistributionOption />
        {(isStraightLife || isSurvivorShip || isPeriodCertain) && (
          <>
            {isSurvivorShip && <AnnuitySurvivorBenefit />}

            {isPeriodCertain && <AnnuitizationDistributionDuration />}

            <MonthlyDistributionAmount />

            {(isAnnuitizationYear || isAnnuitizationStartAtRetirement) && <AnnuityAnnualReturn />}

            <AnnuityPrincipalControl />

            {isAnnuitizationYear && <AnnuitySurrenderSchedule />}

            <AnnuityPurchaseYear />
          </>
        )}
      </>
    );
  }

  return (
    <>
      <AnnuityAnnualReturn />
      <AnnuityPrincipalControl />
      <AnnuitySurrenderSchedule />
      <AnnuityPurchaseYear />
    </>
  );
};
